const PropTypes = require('prop-types');
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');

// Styles
require('./PromoCode.scss');

const { InputSafe } = require('commonsComponents/inputSafe');

class PromoCode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            promotionalCode: props.promotionalCode
        };
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleOnInputChange = this.handleOnInputChange.bind(this);
        this.handleOnInputBlur = this.handleOnInputBlur.bind(this);
        this.handleOnCheck = this.handleOnCheck.bind(this);
        this.handleOnCancelPromotionalCode = this.handleOnCancelPromotionalCode.bind(this);
    }

    handleOnCancelPromotionalCode() {
        const { cancelPromotionalCode } = this.props;
        cancelPromotionalCode();
    }

    handleOnCheck(event) {
        const {promotionalCodeAcceptanceChecboxChecked} = this.props;
        promotionalCodeAcceptanceChecboxChecked(event.target.checked);
    }

    handleOnInputChange(event) {
        const promotionalCode = event.target.value;
        this.setState({promotionalCode: promotionalCode});
        this.props.promotionalCodeSetDirty();
    }

    handleOnInputBlur(event) {
        const promotionalCode = event.target.value;
        this.setState({
            promotionalCode: promotionalCode,
            showPromoCodeWarning : !!promotionalCode
        });
        this.props.promotionalCodeSetDirty();
    }

    handleOnSubmit() {
        const { validatePromotionalCode } = this.props;
        this.setState({showPromoCodeWarning : false});
        validatePromotionalCode(this.state.promotionalCode);
    }

    render() {
        const { contractWizard } = this.props;
        const promotionalCodeValid = contractWizard.get('promotionalCodeValid');
        const promotionalCode = contractWizard.get('promotionalCode');
        const errorState = contractWizard.get('promotionalCodeAcceptanceCheckboxErrorState');
        let errorMessage = contractWizard.get('promotionalCodeErrorMessage');
        const invalidCodeErrorState = contractWizard.get('promotionalCodeInvalidErrorState');
        const promotionalCodeIsDirty = contractWizard.get('promotionalCodeIsDirty');
        const promotionalCodeIsLoading = contractWizard.get('isFetching');
        const inputValue = (promotionalCode && promotionalCodeValid) ? promotionalCode.get('code') : this.state.promotionalCode;
        const buttonDisabled = !inputValue;
        if(this.state.showPromoCodeWarning){
            errorMessage = <FormattedText value="promotions-promocodeWarningMsg" />
        }

        const sideButton = promotionalCodeValid ?
            (<i className="promotional-code__success-icon"></i>) :
            (
                <OKButton
                    disabled={buttonDisabled}
                    modifier="ghost"
                    onClick={this.handleOnSubmit}
                    loading={promotionalCodeIsLoading}
                >
                    <FormattedText value="promotions-getPromotionButton" />
                </OKButton>
            );
        const acceptanceCheckboxLabel = url =>
            (
                <p>
                    <FormattedText value="contractSummary-upgradeToPayrollAccountPromotionalCodeLabel3"/>
                    <OKLink key="promotionalCode" id="promotionalCode" target="_blank" to={url} modifier="emphasize">
                        <FormattedText value="contractSummary-upgradeToPayrollAccountPromotionalCodeLabel4"/>
                    </OKLink>
                </p>
            );
        const promotionInformation = promotionalCode && promotionalCodeValid ?
            (
                <div className="promotional-code__information-box">
                    <h6 className="contract-view__subtitle">
                        <FormattedText value="contractSummary-upgradeToPayrollAccountPromotionalCodeLabel1" />
                    </h6>
                    <div className="promotional-code__description-container row">
                        <div className="col-xs-4">
                            <img src={promotionalCode.get('urlImg')} alt="" className="promotional-code__promotion-image"/>
                        </div>
                        <div className="col-xs-8">
                            <h6 className="contract-view__subtitle ">{promotionalCode.get('title')}</h6>
                            <p>{promotionalCode.get('subTitle')}</p>
                            <OKButton
                                modifier="link-emphasize"
                                onClick={this.handleOnCancelPromotionalCode}
                            >
                                <FormattedText value="contractSummary-upgradeToPayrollAccountPromotionalCodeLabel2" />
                            </OKButton>
                        </div>
                    </div>
                    <div>
                        <div className="promotional-code__separator"></div>
                        <OKCheckbox
                            value={promotionalCode.get('promotionalCodeAcceptanceCheckboxChecked')}
                            onChange={this.handleOnCheck}
                            errorState={errorState}
                            errorMessage={formatText('contractsView-serviceContractErrorMessage')}
                            idName="acceptanceCheckbox"
                            extraClass="promotional-code__acceptance-checkbox"
                            label={acceptanceCheckboxLabel(promotionalCode.get('url'))}>
                        </OKCheckbox>
                    </div>
                </div>
            ) : null;
        return (
            <div>
                <div className="promotional-code">
                    <div>
                        <h6 className="contract-view__subtitle">
                            <FormattedText value="contractsView-checkingAccountPromotionalCodeTitle" />
                        </h6>
                    </div>
                    <div className="promotional-code">
                        <div className="promotional-code__input">
                            <input
                                type="text"
                                defaultValue={this.state.promotionalCode}
                                value={this.state.promotionalCode}
                                onBlur={this.handleBlur}
                                className="ok-input__input promotional-code__input"
                                style={{display: 'none'}}
                            />

                            <InputSafe
                                label={null}
                                placeholder={formatText('contractsView-checkingAccountPromotionalCodeAddCode')}
                                name="promoCode"
                                referenceName="promoCode"
                                type="text"
                                onChange={this.handleOnInputChange}
                                onBlur={this.handleOnInputBlur}
                                value={inputValue}
                                errorState={(!promotionalCodeIsDirty && invalidCodeErrorState) || this.state.showPromoCodeWarning}
                                errorMessage={errorMessage}
                            />
                        </div>
                        <div className="promotional-code__success-container">
                            {sideButton}
                        </div>
                    </div>
                </div>
                {promotionInformation}
            </div>
        );
    }
}

PromoCode.propTypes = {
    promotionalCode: PropTypes.string,
    validatePromotionalCode: PropTypes.func,
    promotionalCodeAcceptanceChecboxChecked: PropTypes.func,
    promotionalCodeSetDirty: PropTypes.func,
    cancelPromotionalCode: PropTypes.func,
    contractWizard: PropTypes.object
};

module.exports = PromoCode;
